export const SET_EMPFEEDBACK_SITECORE_DATA = "SET_EMPFEEDBACK_SITECORE_DATA"
export const POST_EMP_FEEDBACK = 'POST_EMP_FEEDBACK'
export const GET_EMP_FEEDBACK_HISTORY_RECIVE = 'GET_EMP_FEEDBACK_HISTORY_RECIVE'
export const GET_EMP_FEEDBACK_HISTORY_PROVIDE = 'GET_EMP_FEEDBACK_HISTORY_PROVIDE'
export const GET_SENT_REQUESTS = 'GET_SENT_REQUESTS'
